import { Component, Inject, OnInit } from '@angular/core';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { AutoLogoutService } from './auto-logout.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'salveo-site';

  constructor(
    private autoLogoutService: AutoLogoutService,
    @Inject(SESSION_STORAGE) private storage: StorageService
  ) {}

  ngOnInit(): void {
    const user = this.storage.get('login_detail');
    if (user) {
      console.log('✅ User logged in — starting auto logout watcher');
      this.autoLogoutService.startWatcher();
    }
  }
}
